import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';

import { availableLanguages } from '../models/available-languages.const';
import { translationAdapterMethodsFactory } from './translation.adapter-methods';
import { translationFeatureMethodsFactory } from './translation.feature-methods';
import { translationHooksFactory } from './translation.hooks';
import { TranslationScope } from '../models/translation-scope.type';

export type TranslationState = {
  _loadedScopes: Set<TranslationScope>;
  _translations: Map<string, string>;
  availableLanguages: string[];
  currentLanguage: string;
};

const initialState: TranslationState = {
  _loadedScopes: new Set(),
  _translations: new Map(),
  availableLanguages,
  currentLanguage: 'en',
};

export const TranslationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(translationAdapterMethodsFactory),
  withMethods(translationFeatureMethodsFactory),
  withHooks(translationHooksFactory),
);
